import locale from '../en-GB.json';

const settingsTargets = [
  window.reactSettings,
  window.reactSettingsExhibitorHubHomepage,
  window.reactSettingsExhibitorHubHeader,
];

settingsTargets.forEach((settings) => {
  if (!settings?.props) return;
  settings.props.localisation = settings.props.localisation || {};
  settings.props.localisation['en-GB'] = locale;
});
